import Vue from 'vue'
import Router from 'vue-router'
import VueMeta from 'vue-meta'

import Login from './views/Login.vue'
import Home from './views/Home.vue'
import Form from './views/Form.vue'
import Competition from './views/Competition.vue'
import Manual from './views/Manual.vue'
import Qa from './views/Qa.vue'
import Lottery from './views/Lottery.vue'
import Vote from './views/Vote.vue'
import Config from './views/Config.vue'
import GroupConfig from './views/GroupConfig.vue'
import Account from './views/Account.vue'
import Support from './views/Support.vue'
import Preference from './views/Preference.vue'

Vue.use(Router)
Vue.use(VueMeta)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { title: 'Login' },
    },
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/forms/:period/:level',
      name: 'form',
      component: Form,
    },
    {
      path: '/competition',
      name: 'competition',
      component: Competition,
    },
    {
      path: '/manual',
      name: 'manual',
      component: Manual,
    },
    {
      path: '/faq',
      name: 'qa',
      component: Qa,
    },
    {
      path: '/lucky-draw/:period',
      name: 'lottery',
      component: Lottery,
    },
    {
      path: '/vote',
      name: 'vote',
      component: Vote,
    },
    {
      path: '/configuration',
      name: 'config',
      component: Config,
    },
    {
      path: '/group-rules',
      name: 'groupConfig',
      component: GroupConfig,
    },
    {
      path: '/account',
      name: 'account',
      component: Account,
    },
    {
      path: '/about',
      name: 'support',
      component: Support,
      meta: { title: '關於' },
    },
    {
      path: '/preference',
      name: 'preference',
      component: Preference,
    },
    { path: '*', redirect: '/' },
  ],
})
